
export default {
    searchPublisherPaymentDetails(params) {
        let path = '/publisher/publisherPaymentDetails.search';
        params = params || {};
        params.fields = 'publisher_payment_details.activation_code,publisher_payment_details.created_at,publisher_payment_details.updated_at,publisher_payment_details.payment_dictionary';
        return this.makeRequest(path, params);
    },

    sendActivationCodePublisherPaymentDetails(params) {
        let path = '/publisher/publisherPaymentDetails.sendActivationCode';
        params = params || {};
        return this.makeRequest(path, params);
    },

    getPaymentSystems() {
        let path = '/publisher/publisherPaymentDetails.getPaymentSystems';
        return this.makeRequest(path);
    },

    getAllowPaymentSystems() {
        let path = '/publisher/publisherPaymentDetails.getAllowPaymentSystems';
        return this.makeRequest(path);
    },

    getPaymentMethods() {
        let path = '/publisher/publisherPaymentDetails.getPaymentMethods';
        return this.makeRequest(path);
    },

    getPaymentMethodStat() {
        let path = '/publisher/publisherPaymentDetails.getPaymentMethodStat';
        return this.makeRequest(path);
    },

    createPaymentAccount(params) {
        let path = '/publisher/publisherPaymentDetails.create';
        params = params || '';
        return this.makeRequest(path, params);
    },

    editPaymentAccount(params) {
        let path = '/publisher/publisherPaymentDetails.edit';
        params = params || '';
        return this.makeRequest(path, params);
    },

    createWMR(params) {
        let path = '/publisher/publisherPaymentDetails.createWMR';
        params = params || '';
        return this.makeRequest(path, params);
    },

    createWMZ(params) {
        let path = '/publisher/publisherPaymentDetails.createWMZ';
        params = params || '';
        return this.makeRequest(path, params);
    },

    createYAD(params) {
        let path = '/publisher/publisherPaymentDetails.createYAD';
        params = params || '';
        return this.makeRequest(path, params);
    },

    createBTC(params) {
        let path = '/publisher/publisherPaymentDetails.createBTC';
        params = params || '';
        return this.makeRequest(path, params);
    },

    createEPAYMENTSRUB(params) {
        let path = '/publisher/publisherPaymentDetails.createEPAYMENTSRUB';
        params = params || '';
        return this.makeRequest(path, params);
    },

    createEPAYMENTSUSD(params) {
        let path = '/publisher/publisherPaymentDetails.createEPAYMENTSUSD';
        params = params || '';
        return this.makeRequest(path, params);
    },

    createPAXUMUSD(params) {
        let path = '/publisher/publisherPaymentDetails.createPAXUMUSD';
        params = params || '';
        return this.makeRequest(path, params);
    },

    createPAYPALUSD(params) {
        let path = '/publisher/publisherPaymentDetails.createPAYPALUSD';
        params = params || '';
        return this.makeRequest(path, params);
    },

    createQIWI(params) {
        let path = '/publisher/publisherPaymentDetails.createQIWI';
        params = params || '';
        return this.makeRequest(path, params);
    },

    createVISAMCRUB(params) {
        let path = '/publisher/publisherPaymentDetails.createVISAMCRUB';
        params = params || '';
        return this.makeRequest(path, params);
    },

    createVISAMCUSD(params) {
        let path = '/publisher/publisherPaymentDetails.createVISAMCUSD';
        params = params || '';
        return this.makeRequest(path, params);
    },

    createCAPITALISTRUB(params) {
        let path = '/publisher/publisherPaymentDetails.createCAPITALISTRUB';
        params = params || '';
        return this.makeRequest(path, params);
    },

    createCAPITALISTUSD(params) {
        let path = '/publisher/publisherPaymentDetails.createCAPITALISTUSD';
        params = params || '';
        return this.makeRequest(path, params);
    },

    editVISAMCRUB(params) {
        let path = '/publisher/publisherPaymentDetails.editVISAMCRUB';
        params = params || '';
        return this.makeRequest(path, params);
    },

    editVISAMCUSD(params) {
        let path = '/publisher/publisherPaymentDetails.editVISAMCUSD';
        params = params || '';
        return this.makeRequest(path, params);
    },

    editQIWI(params) {
        let path = '/publisher/publisherPaymentDetails.editQIWI';
        params = params || '';
        return this.makeRequest(path, params);
    },

    editPAXUMUSD(params) {
        let path = '/publisher/publisherPaymentDetails.editPAXUMUSD';
        params = params || '';
        return this.makeRequest(path, params);
    },

    editPAYPALUSD(params) {
        let path = '/publisher/publisherPaymentDetails.editPAYPALUSD';
        params = params || '';
        return this.makeRequest(path, params);
    },

    editEPAYMENTSUSD(params) {
        let path = '/publisher/publisherPaymentDetails.editEPAYMENTSUSD';
        params = params || '';
        return this.makeRequest(path, params);
    },

    editEPAYMENTSRUB(params) {
        let path = '/publisher/publisherPaymentDetails.editEPAYMENTSRUB';
        params = params || '';
        return this.makeRequest(path, params);
    },

    editWMR(params) {
        let path = '/publisher/publisherPaymentDetails.editWMR';
        params = params || '';
        return this.makeRequest(path, params);
    },

    editWMZ(params) {
        let path = '/publisher/publisherPaymentDetails.editWMZ';
        params = params || '';
        return this.makeRequest(path, params);
    },

    editYAD(params) {
        let path = '/publisher/publisherPaymentDetails.editYAD';
        params = params || '';
        return this.makeRequest(path, params);
    },

    editBTC(params) {
        let path = '/publisher/publisherPaymentDetails.editBTC';
        params = params || '';
        return this.makeRequest(path, params);
    },

    editCAPITALISTRUB(params) {
        let path = '/publisher/publisherPaymentDetails.editCAPITALISTRUB';
        params = params || '';
        return this.makeRequest(path, params);
    },

    editCAPITALISTUSD(params) {
        let path = '/publisher/publisherPaymentDetails.editCAPITALISTUSD';
        params = params || '';
        return this.makeRequest(path, params);
    },

    deletePaymentAccount(params) {
        let path = '/publisher/publisherPaymentDetails.delete';
        params = params || '';
        return this.makeRequest(path, params);
    },
};